import { useSelector } from 'react-redux';
import { selectIsActive } from './selectors';

// eslint-disable-next-line import/prefer-default-export
export const useModuleIsActive = () => !!useSelector(selectIsActive);
